import { AttachmentDto } from '@/services/dtos'
import { Grid, Typography } from '@mui/material'
import React from 'react'

interface Props {
  file?: File | null
  attachment?: AttachmentDto
}

export const FilePreview: React.FC<Props> = ({ file, attachment }) => {
  const src = file ? URL.createObjectURL(file) : attachment?.url || null

  if (!src) {
    return (
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          bgcolor: 'grey.100',
          height: '100%',
          width: '100%',
          borderRadius: 2,
        }}
      >
        <Typography color="textSecondary" variant="body2">
          Aperçu non disponible
        </Typography>
      </Grid>
    )
  }

  const contentType =
    file?.type ||
    attachment?.contentType ||
    ''

  const isImage = contentType.startsWith('image/')
  const isPdf = contentType === 'application/pdf'

  if (isImage) {
    return (
      <img
        src={src}
        alt="aperçu du fichier"
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          height: 'auto',
          borderRadius: 8,
        }}
      />
    )
  }

  if (isPdf) {
    return (
      <iframe
        src={src}
        width="100%"
        height="100%"
        style={{
          border: '1px solid #ddd',
          borderRadius: 8,
        }}
        title="aperçu PDF"
      />
    )
  }

  return (
    <Typography variant="body2" color="textSecondary">
      Aperçu non disponible pour ce type de fichier
    </Typography>
  )
}
